module.exports = __webpack_public_path__ + "2980083682e94d33a66eef2e7d612519.svg";